const keyMap = {
  13: "OK",
  8: "BACK",
  38: "ARROW_UP",
  39: "ARROW_RIGHT",
  40: "ARROW_DOWN",
  37: "ARROW_LEFT",
  118: "MEDIA_REWIND",
  119: "MEDIA_FAST_FORWARD",
  112: "TRIANGLE",
  32: "SQUARE"
};

export default {
  keyMap
};
